import { createSlice } from '@reduxjs/toolkit'


export const BridgeUrlSlice = createSlice({
    name: 'url',
    initialState: {
        bUrl: '',
        wsUrl: '',
    },
    reducers: {
        setBridgeUrl: (state, action) => {
            state.bUrl = action.payload
        },
        setSocketUrl: (state, action) => {
            state.wsUrl = action.payload
        },
    },
})

export const { setBridgeUrl, setSocketUrl } = BridgeUrlSlice.actions
export default BridgeUrlSlice.reducer